import type { App } from 'vue'
import '@/assets/css/floating-vue.css'
import FloatingVue from 'floating-vue'

export const floatingVue = {
  install: (app: App) => {
    app.use(FloatingVue, {
      themes: {
        'light-tooltip': {
          $extend: 'tooltip',
        },
      },
    })
  },
}
